import { ChangeEvent, useEffect, useState } from 'react'
import { AnimatedFragment } from '../Animator/AnimatedFragment'
import { IInputProps } from './Input'

export const TextareaInput = (props: IInputProps) => {
  const [valid, setValid] = useState(false)
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    if (props.onValidUpdate && props.name) {
      props.onValidUpdate(props.name, valid)
    }
  }, [valid])

  useEffect(() => {
    validate(props.value)
    setValue(props.value ?? '')
  }, [props.value])

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const v = e.currentTarget.value

    validate(v)
    setValue(v)
    props.onChange(v)
  }

  const validate = (value?: string) => {
    if (props.required && !value) {
      return setValid(false)
    }

    setValid(true)
  }

  return (
    <AnimatedFragment visible={props.visible === undefined ? true : props.visible}>
      <div className={['formArea', props.validate || valid ? '' : 'not-valid'].join(' ')}>
        <div className="form-group">
          {!!props.label && (
            <label>
              <div className="label">{props.label || ''}</div>
            </label>
          )}
          <textarea readOnly={props.readonly} name={props.name} autoComplete="none" onChange={onChange} value={value} />
        </div>
      </div>
    </AnimatedFragment>
  )
}
